import BoletimHeader from "../BoletimHeader/BoletimHeader";
import Boletim25 from "./2025/Boletim25";
import Boletim26 from "./2026/Boletim26";

import styles from "./Boletim.module.css";
import Loader from "./Loader/Loader";

function Boletim({ pdfTargetRef, boletim, period, isLoading }) {
	return (
		<div
			className={styles.container}
			ref={pdfTargetRef}
		>
			<BoletimHeader period={period} />
			{isLoading && <Loader />}
			{period.includes('25') && <Boletim25 boletim={boletim} isLoading={isLoading} />}
            {period.includes('26') && <Boletim26 boletim={boletim} isLoading={isLoading} />}
			{!isLoading && !boletim && (
				<div className={styles.errorContainer}>
					<div className={styles.errorBody}>
						Não foi possível encontrar o aluno ou o RA consultado
						está incorreto.
					</div>
				</div>
			)}
		</div>
	);
}

export default Boletim;
